export default __webpack_public_path__ + "static/media/DeepSeaCreature_02.95b0581e.png";